import React, { useEffect, useState } from "react";
import { createPopper } from "@popperjs/core";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { gain_user } from "../../../store/acion/index";

const UserDropdown = (props) => {
  // const [data_gain, setdata_gain] = useState(false);
  // const [request_data, setrequest_data] = useState();

  // const re_load = async () => {
  //   if (props.teacher == "fail") {
  //     setdata_gain(false);
  //     await props.gain();
  //     console.log("fail>>>>>.");
  //   } else {
  //     console.log("yes>>>>>.", props.teacher);

  //     let asd = await props.teacher;
  //     await setrequest_data(
  //       await asd.find((e) => e.uid == localStorage.getItem("teacher_uid"))
  //     );

  //     setdata_gain(true);
  //   }
  // };

  // useEffect(() => {
  //   re_load();
  // })

  const [data_gain, setdata_gain] = useState(false);
  const [request_data, setrequest_data] = useState();

  useEffect(() => {
    // if (props.request!='fail') {
    //   console.log("sdsadas",props.request);
    //   let arr=  props.request.filter((e)=>(e.user_uid==localStorage.getItem('user_uid')))
    //   setrequest_data(props.request)
    // }
  }, [data_gain]);

  const re_load = async () => {
    if (props.user == "fail") {
      setdata_gain(false);
      await props.gain_user();
      console.log("fail>>>>>.");
    } else {
      // console.log("yes>>>>>.", props.user);

      let asd = await props.user;
      await setrequest_data(
        await asd.find((e) => e.uid == localStorage.getItem("user_uid"))
      );

      setdata_gain(true);
    }
  };

  useEffect(() => {
    re_load();
  });

  let navigate = useNavigate();
  // dropdown props
  const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
  const btnDropdownRef = React.createRef();
  const popoverDropdownRef = React.createRef();
  const openDropdownPopover = () => {
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: "bottom-end",
    });
    setDropdownPopoverShow(true);
  };
  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };
  return (
    <>
      {/* {console.log("?????----", request_data)} */}
      <a
        className="text-blueGray-500 block"
        href="#pablo"
        ref={btnDropdownRef}
        onClick={(e) => {
          e.preventDefault();
          dropdownPopoverShow ? closeDropdownPopover() : openDropdownPopover();
        }}
      >
        {/* {console.log(">>>>>>>>>>>>",request_data)} */}
        <div className="items-center flex">
          <span className="w-12 h-12 text-sm text-white bg-blueGray-200 inline-flex items-center justify-center rounded-full">
            {data_gain ? (
              <img
                alt="Profile Picture"
                referrerPolicy='no-referrer'

                className="responsImage w-full rounded-full align-middle border-none shadow-lg"
                src={request_data.pic}


              />
            ) : (
              ""
            )}
          </span>
        </div>
      </a>
      <div
        ref={popoverDropdownRef}
        className={
          (dropdownPopoverShow ? "block " : "hidden ") +
          "bg-white text-base z-5000 float-left py-2 list-none text-left rounded shadow-lg mt-1"
        }
        style={{ minWidth: "12rem" }}
        onClick={(e) => {
          navigate("/");
          localStorage.removeItem('user_uid');

        }}
      >
        <a
          href="#pablo"
          style={{ display: "flex", flexDirection: "row" }}
          className={
            "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          }
         
        >
          {/* {console.log("sasdasdasdasd",request_data.pic)} */}
          {/* <img
            src={request_data.pic}
            style={{ width: 20, marginRight: 10 }}
          /> */}
          Logout
        </a>
      </div>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    gain_user: () => dispatch(gain_user()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(UserDropdown);
